// frame-cart-relationships.js

class FrameCartRelationships {

  constructor() {
    this.init();
  }

  init() {

    document.addEventListener(
      'cart:updated',
      async (event) => {
        const promise =
          this.handleFrameRelationships(
            event
          );

        event.detail.waitUntil.push(
          promise
        );
      }
    );
  }

  async handleFrameRelationships(event) {

    const {
      removedItem
    } = event.detail;

    if (!removedItem) {
      return;
    }

    const groupKey =
      removedItem.properties?._groupKey;

    if (!groupKey) {
      return;
    }

    const isFrame =
      !!removedItem.properties?.FrameFor;

    const isPrint =
      !!removedItem.properties?.Frame_included;

    const cartResponse = await fetch(
      `${window.Theme.routes.cart_url}.js`
    );

    const freshCart =
      await cartResponse.json();

    const itemStillExists =
      freshCart.items.some(
        (item) =>
          item.key === removedItem.key
      );

    if (itemStillExists) {
      return;
    }

    const relatedItems =
      freshCart.items.filter(
        (item) =>
          item.properties?._groupKey ===
          groupKey
      );

    for (const item of relatedItems) {

      const updatedProperties = {
        ...item.properties
      };

      if (isFrame) {

        updatedProperties.Frame_included =
          'No';

        delete updatedProperties._groupKey;
      }

      if (isPrint) {

        delete updatedProperties.FrameFor;
        delete updatedProperties._groupKey;
      }

      // REMOVE EXISTING
      await fetch(
        `${window.Theme.routes.cart_change_url}.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        }
      );

      // RE-ADD UPDATED
      const addResponse = await fetch(
        `${window.Theme.routes.cart_add_url}.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: item.id,
              quantity: item.quantity,
              properties:
                updatedProperties
            }]
          })
        }
      );

      const addData =
        await addResponse.json();
    }
  }
}

new FrameCartRelationships();